// The editing bar reveals only while the mouse is over the post's VISUAL (or the bar itself).
// This lives in a tiny external store — NOT the editor context — on purpose: a hover toggle
// must not re-render the whole composer (canvas, overlay, dock), which would also cancel any
// in-flight inline-edit autosave. Consumers subscribe selectively: the visual calls show/hide
// (stable, no re-render), the bar reads `active`.
//
// hide() is debounced so moving the mouse from the image up to the bar (crossing the gap)
// doesn't drop it; landing on the caption lets it fade.

import { create } from 'zustand'

interface VisualHoverStore {
  active: boolean
  show: () => void
  hide: () => void
}

let hideTimer: ReturnType<typeof setTimeout> | null = null

export const useVisualHover = create<VisualHoverStore>(set => ({
  active: false,
  show: () => {
    if (hideTimer) {
      clearTimeout(hideTimer)
      hideTimer = null
    }
    set({ active: true })
  },
  hide: () => {
    if (hideTimer) clearTimeout(hideTimer)
    hideTimer = setTimeout(() => set({ active: false }), 140)
  },
}))
